import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Location", href: "/location" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (href: string) => {
    if (href === "/") return location.pathname === "/";
    return location.pathname.startsWith(href);
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 bg-white border-b border-[#EBEBEB] ${
        scrolled ? "py-3" : "py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <div className="h-10 w-auto flex items-center justify-center">
            <img
              src="https://storage.readdy-site.link/project_files/1caa1cee-5f7c-4340-8ab6-e4fecf0e11fe/5ee83760-d348-4b18-a1b6-b409430da712_tmp5zjj6o9t.webp?v=62c8a9ba617712446a98074483998f7e"
              alt="The Design Proposal Logo"
              className="h-10 w-auto object-contain"
            />
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive(link.href)
                  ? "text-[#C9A961]"
                  : "text-[#1A1A1A] hover:text-[#C9A961]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href="tel:+18005550199"
            className="flex items-center gap-2 text-sm font-medium text-[#5C5C5C] hover:text-[#C9A961] transition-colors whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line"></i>
            </div>
            (800) 555-0199
          </a>
          <Link
            to="/#proposal"
            className="whitespace-nowrap bg-[#C9A961] text-white text-sm font-medium px-5 py-2.5 rounded-md hover:bg-[#b8924d] transition-colors duration-300 cursor-pointer"
          >
            Get Your Proposal
          </Link>
        </div>

        <button
          className="lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer text-[#1A1A1A]"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-white border-t border-[#F0EDE8] px-6 py-4">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`block py-2.5 text-sm border-b border-[#F8F6F3] ${
                isActive(link.href) ? "text-[#C9A961] font-medium" : "text-[#1A1A1A] hover:text-[#C9A961]"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-4 flex flex-col gap-3">
            <a
              href="tel:+18005550199"
              className="flex items-center gap-2 text-sm font-medium text-[#1A1A1A] bg-[#F8F6F3] px-4 py-3 rounded-md"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-line text-[#C9A961]"></i>
              </div>
              Call (800) 555-0199
            </a>
            <Link
              to="/#proposal"
              className="whitespace-nowrap bg-[#C9A961] text-white text-sm font-medium px-5 py-3 rounded-md text-center cursor-pointer hover:bg-[#b8924d] transition-colors"
            >
              Get Your Design Proposal
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
